export default __webpack_public_path__ + "static/media/website.2ba79c50.png";